export default __webpack_public_path__ + "media/images/mobile-logo-732feb2247e1f6bb2f701099dbe0801a.svg";